<template>
  <div style="background-color: #F5F7FA;height: 100%;">
    <div style="padding: 0px;">
        <el-row style="width:100%;padding: 5px;">
          <el-col :span="21">
            <el-col :span="24" style="padding:0 5px ">
              <Daterange :startTime="startTime"  is-datetime="datetime" :endTime="endTime" @dataChange='dataChange'></Daterange>
            </el-col>
          </el-col>
          <el-col :span="3">
            <el-button style="float: right;" type="primary" size="mini" @click="submit">搜索</el-button>
          </el-col>
        </el-row>
      </div>
      <div class="body">
        <div v-show="isShow" class="hint">
          获取轨迹中,请等待。。。
        </div>

        <baidu-map
            class="map"
            :center="center"
            :zoom="15"
            :scroll-wheel-zoom="true"
            :mapClick="false">

          <bm-marker :position="center" animation="BMAP_ANIMATION_BOUNCE"></bm-marker>

          <bm-polyline :path="locationList" stroke-color="rgba(29, 211, 138, 1)" :stroke-opacity="1" :stroke-weight="3"></bm-polyline>

        </baidu-map>
      </div>

    </div>
</template>

<script>


import {timefilters, timeStr} from "@/common/times";
import Daterange from "@/components/Daterange";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";


export default {
  name: "BaiduMapMotionCurve",
  data() {
    return {
      isShow:false,
      userDeviceCode:'',
      startTime:'',
      endTime:'',
      locationList:[],
      center: {
        lng: '',
        lat: ''
      },
    };
  },
  components: {
    Daterange
  },
  methods: {
    init(userDeviceCode) {
      this.userDeviceCode=userDeviceCode;
      this.endTime=timefilters(new Date())
      this.startTime=timefilters(new Date(new Date()-1000 * 60 * 60 * 24))

      this.center = {lng:116.394783,lat:39.937289};

    },
    closeSelf() {
      this.$emit('closeBaiduMapMotionCurve')
    },
    dataChange(val){
      this.startTime=val[0]
      this.endTime=val[1]
    },


    submit(){
      this.isShow=true;
      this.$axios({
        method: 'post',
        url: this.$deviceUrl + "Positioning/MotionCurve",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          userDeviceCode: this.userDeviceCode,
          startTime:this.startTime,
          endTime:this.endTime
        }
      }).then(
          (response) => {
            if (response.data.error === 0) {
              this.isShow=false;
              console.log(response.data.data)
              if(response.data.data==null || response.data.data.length==0 ){
                this.$message({type: 'info', message: '该时间段无运动轨迹'});
              }else {

                var data2 = JSON.stringify(response.data.data);
                this.locationList = JSON.parse(data2.replace(/lon/g, 'lng'));

                this.center.lat=this.locationList[0].lat;
                this.center.lng=this.locationList[0].lng;
              }
            } else if (response.data.error === 1) {
              this.isShow=false;
              this.$message.error({type: 'info', message: response.data.message});
            } else {
              this.isShow=false;
              this.$message.error({type: 'info', message: '查询失败'});
            }
          }
      )



    },


  }
};

</script>





<style lang="scss" scoped>
.map{
  width: 100%;
  height: 350px;
}
.body{
  position: relative;
}
.hint{
  position: absolute;
  z-index: 1000;
  color: red;
  font-size: 20px;
  margin: 10px;
  // background: #F2F6FC;
}
</style>
